import type { Ref } from 'vue';

export interface NameTrainingDateRow {
  name: string;
  nameError: string | null;
  trainingDate: Date | null;
}

export function useNameTrainingDateRow<TRow extends NameTrainingDateRow>(rows: Ref<TRow[]>) {
  function setName(index: number, value: string): void {
    const row = rows.value[index];
    if (!row) return;
    row.name = value;
    row.nameError = null;
  }

  function setTrainingDate(index: number, value: Date | null): void {
    const row = rows.value[index];
    if (row) row.trainingDate = value;
  }

  return { setName, setTrainingDate };
}
